import {
  organizerErrorSelector,
  organizerInfoSelector,
  organizerIsLoadedSelector,
  organizerIsLoadingSelector,
  organizerIsSavingSelector,
  organizerLoadedTournamentIdSelector,
} from 'modules/organizer/store/organizer/selectors';
import { useMemo } from 'react';

import { useSelector } from 'react-redux';

export const useOrganizer = () => {
  const isLoading = useSelector(organizerIsLoadingSelector);
  const isLoaded = useSelector(organizerIsLoadedSelector);
  const isSaving = useSelector(organizerIsSavingSelector);
  const info = useSelector(organizerInfoSelector);
  const loadedTournamentId = useSelector(organizerLoadedTournamentIdSelector);
  const error = useSelector(organizerErrorSelector);

  return useMemo(
    () => ({
      isLoading,
      isLoaded,
      isSaving,
      info,
      loadedTournamentId,
      error,
    }),
    [isLoading, isLoaded, isSaving, info, loadedTournamentId, error],
  );
};
